var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.text * 1),expression:"text * 1"}],staticClass:"sku-tips"},[_c('span',[_vm._v("返"+_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }